import React from 'react';
import { RouteComponentProps, Route } from 'react-router-dom';

import { buildRoutesFromStructure } from 'modules/shared-navigation';
import { IdRouteParams, SubRouterProps } from 'modules/shared/types';
import { NavigationElement, Node } from 'modules/shared/models';
import { NotFound, Switch } from 'modules/shared/components';

import { concatUrl } from 'modules/shared/utils';
import { ContentSelector } from './components';

export const Router: React.FC<SubRouterProps> = (props: SubRouterProps) => {
    const { sourceStructureNode, navigationTree } = props;

    if (!sourceStructureNode || !sourceStructureNode.nodes || sourceStructureNode.nodes.length === 0) {
        return <React.Fragment />;
    }

    return (
        <Switch>
            <Route
                path={concatUrl([navigationTree.path, 'preview/:template/:id?'])}
                render={(subProps: RouteComponentProps<IdRouteParams>) => {
                    const { id, template } = subProps.match.params;
                    const path = subProps.location.pathname;

                    const virtualNavigationTree: NavigationElement = {
                        path: path.substring(0, path.lastIndexOf('/')),
                    };
                    const virtualSourceStructureNode: Node = {};

                    return (
                        <ContentSelector
                            id={id || '00000000-0000-0000-0000-000000000000'}
                            template={template}
                            navigationTree={virtualNavigationTree}
                            sourceStructureNode={virtualSourceStructureNode}
                        />
                    );
                }}
            />
            {buildRoutesFromStructure(
                ContentSelector,
                sourceStructureNode.nodes,
                navigationTree,
                undefined,
                true,
                true,
            )}
            <Route component={NotFound} />
        </Switch>
    );
};
